import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path : '/order/:id',
  /*  Async getComponent is only invoked when route matches   */
  getComponents (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Order = require('./containers/OrderDetailContainer').default
      const reducer = require('../../store/order').default

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'order', reducer })

      /*  Return getComponent   */
      cb(null, {category:null, main:Order})

    /* Webpack named bundle   */
    }, 'orderDetail')
  }
})



// WEBPACK FOOTER //
// ./src/routes/OrderDetail/index.js